module.exports = __webpack_public_path__ + "img/coin.da00d6bc.webp";